import { render, staticRenderFns } from "./btn-primary3.vue?vue&type=template&id=6b685621&scoped=true&"
import script from "./btn-primary3.vue?vue&type=script&lang=js&"
export * from "./btn-primary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b685621",
  null
  
)

export default component.exports